// extracted by mini-css-extract-plugin
export default {"suggestions":"suggestions-fS1I130I","title":"title-nXiPZ09p","suggestion":"suggestion-NObtaf6Q"};